import { httpClientInterface } from 'app-components/utils/core';
import { getServiceUrl } from 'app-components/utils/core/interfaces/httpClientInterface';
import { filteredArraySchema } from 'app-components/utils/zodHelpers';
import z from 'zod';
import type { AiMemoriesStorageData } from './aiMemoriesTypes';
import { AiMemoriesStorageDataSchema } from './aiMemoriesTypes';

const RemoteAiMemoriesResourceSchema = AiMemoriesStorageDataSchema.and(z.object({ id: z.string() }));

const GetAiMemoriesResponseSchema = z.object({
  resources: filteredArraySchema(RemoteAiMemoriesResourceSchema),
});

const PostAiMemoriesResponseSchema = z.object({
  resource: RemoteAiMemoriesResourceSchema,
  id: z.string(),
  clientId: z.string().optional(),
});
export type PostAiMemoriesResponseType = z.infer<typeof PostAiMemoriesResponseSchema>;

const PutAiMemoriesResponseSchema = z.object({
  resource: RemoteAiMemoriesResourceSchema,
  id: z.string(),
});
export type PutAiMemoriesResponseType = z.infer<typeof PutAiMemoriesResponseSchema>;

export default {
  async create(resource: AiMemoriesStorageData & { clientId: string }) {
    const requestUrl = `${getServiceUrl()}/wildcard/ai-agent-memories`;
    const response = await httpClientInterface.send('POST', requestUrl, resource);
    return PostAiMemoriesResponseSchema.parse(response.data);
  },
  async fetch() {
    const requestUrl = `${getServiceUrl()}/wildcard/ai-agent-memories`;
    const response = await httpClientInterface.send('GET', requestUrl);
    return GetAiMemoriesResponseSchema.parse(response.data).resources;
  },
  async update(resource: AiMemoriesStorageData & { id: string }) {
    const requestUrl = `${getServiceUrl()}/wildcard/ai-agent-memories/${resource.id}`;
    const response = await httpClientInterface.send('PUT', requestUrl, resource);
    return PutAiMemoriesResponseSchema.parse(response.data);
  },
  async delete(id: string) {
    const requestUrl = `${getServiceUrl()}/wildcard/ai-agent-memories/${id}`;
    await httpClientInterface.send('DELETE', requestUrl);
  },
} as const;
